import { render, staticRenderFns } from "./ChucNangListAddNew.vue?vue&type=template&id=b2b7d8b0&"
import script from "./ChucNangListAddNew.vue?vue&type=script&lang=js&"
export * from "./ChucNangListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ChucNangListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports